import { useState } from 'react';

import ShareIcon from '@/assets/all-icons/share-icon';
import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import ThreeDotsHorizontal from '@/shared-components/icons/components/public/styles/ThreeDotsHorizontal';

import ProfileOptions from './components/ProfileOptions';

import './index.css';

export default function ProfileTopButtons({ fetchData, internal }) {
  const [open, setOpen] = useState(false);
  const goBackHandler = useGoBack("/");

  if(!internal) {
    return (
      <>
        <BackArrowIcon className="profile-top-buttons__go-back" onClick={goBackHandler}/>

        {navigator.share && (
          <ShareIcon 
            className="profile-top-buttons__share-button" 
            onClick={()=>{
              navigator.share({
                title: `@${fetchData.user_username}'s profile`,
                text: `Take a look at @${fetchData.user_username}'s profile:`,
                url: `https://suarte.art/user/${fetchData.user_username}`
              });
            }}
          />
        )}
      </>
    );
  } else {
    return (
      <>
        <div className="profile-top-buttons__group">
          <ThreeDotsHorizontal className={`profile-top-buttons__profile-options-icon${open ? " active" : ""}`} onClick={() => setOpen(true)} />
        </div>
    
        <ProfileOptions 
          open={open} 
          setOpen={setOpen} 
          fetchData={fetchData}
        />
      </>
    );
  }
}
